import { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { clearLoggedUserReducer } from '../redux/slice/logged-user';
import { clearAccessTokenReducer } from '../redux/slice/access-token';
import { getCheckSession } from '../services/api-services';
import { toastEmitter } from '../../utils/utilities';
import { store } from '../redux/store';

const WebSiteLogout = ({ children }) => {
    const navigation = useNavigate();
    const dispatch = useDispatch();

    const events = [
        "load",
        "mousemove",
        "mousedown",
        "click",
        "scroll",
        "keypress",
    ];
    let timer;

    // this function sets the timer that logs out the user after 10 secs
    const handleLogoutTimer = () => {
        timer = setTimeout(() => {
            resetTimer();
            Object.values(events).forEach((item) => {
                window.removeEventListener(item, resetTimer);
            });
            logoutAction();
        }, 600000); // 10000ms = 10secs. You can change the time.


    };
    // this resets the timer if it exists.
    const resetTimer = () => {
        if (timer) clearTimeout(timer);
    };

    // when component mounts, it adds an event listeners to the window
    // each time any of the event is triggered, i.e on mouse move, click, scroll, keypress etc, the timer to logout user after 10 secs of inactivity resets.
    // However, if none of the event is triggered within 10 secs, that is app is inactive, the app automatically logs out.
    useEffect(() => {
        Object.values(events).forEach((item) => {
            window.addEventListener(item, () => {
                resetTimer();
                handleLogoutTimer();
            });
        });
    }, []);

    // session check
    const checkSession = async () => {
        try {
            const session = await getCheckSession();
            if (session?.data?.responseCode === 401) {
                localStorage.removeItem("nMenuData")
                store.dispatch(clearLoggedUserReducer());
                store.dispatch(clearAccessTokenReducer());
                navigation('/');
                return toastEmitter("error", "Session expired, Please login again!");
            }
        } catch (error) {
            console.log("Session Expired !")
        }
    };

    useEffect(() => {
        const interval = setInterval(checkSession, 20000); // Check every 20 seconds
        return () => {
            clearInterval(interval); // Clean up on unmount
        };
    }, []);

    // logs out user by clearing out auth token in localStorage and redirecting url to /signin page.
    const logoutAction = () => {
        localStorage.removeItem("nMenuData")
        dispatch(clearAccessTokenReducer())
        dispatch(clearLoggedUserReducer())
        window.location.href = "/"
        localStorage.clear();
    };
    return children;
}

export default WebSiteLogout;
